import NewActivity from './NewActivity'
export default NewActivity
